import { CreditCardOutlined } from '@ant-design/icons';
import { gql } from '@apollo/client';
import { useAsyncEffect } from 'ahooks';
import { Button } from 'antd';
import { useMutation } from 'hooks/apollo';
import useGlobalContext from 'hooks/useGlobalContext';
import useQueryParams from 'hooks/useQueryParams';
import React from 'react';
import { useHistory } from 'react-router-dom';

const SETUP_PAYMENT_MUTATION = gql`
  mutation AddPaymentMethod($successUrl: String!, $cancelUrl: String!, $customerId: ID!) {
    addPaymentMethod(successUrl: $successUrl, cancelUrl: $cancelUrl, customerId: $customerId)
  }
`;

const SetupPaymentButton = ({ customerId, onSuccess, onCancel }) => {
  const [addPaymentMethod, { loading: paymentMethodLoading }] = useMutation(SETUP_PAYMENT_MUTATION);
  const { message } = useGlobalContext();
  const query = useQueryParams();
  const history = useHistory();

  const queryParam = 'payment';

  const result = query.get(queryParam);

  const onAddPaymentMethod = async () => {
    const { data } = await addPaymentMethod({
      variables: {
        successUrl: `${window.location.href}?${queryParam}=success`,
        cancelUrl: `${window.location.href}?${queryParam}=cancel`,
        customerId,
      },
    });
    window.location.href = data.addPaymentMethod;
  };

  useAsyncEffect(async () => {
    if (result) {
      if (result === 'success') {
        onSuccess?.();
      }
      if (result === 'cancel') {
        message.error('Payment setup cancelled');
        onCancel?.();
      }
      history.replace(history.location.pathname);
    }
  }, [result]);

  return <Button icon={<CreditCardOutlined />} onClick={onAddPaymentMethod} loading={paymentMethodLoading} type="primary">Register payment card</Button>;
};

export default SetupPaymentButton;
